import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { PagesRoutes } from '../../../routing/PagesRoutes';
import PlatformGuard from './shared/PlatformGuard';
import { PlatformTabsInner, PlatformTabsNav } from './shared/platformPageStyles';
import { styled } from '../../shared/Theme/theme';

const tabs = [
    { path: PagesRoutes.PlatformHub, label: 'Home', end: true },
    { path: PagesRoutes.PlatformCompanies, label: 'Organizations' },
    { path: PagesRoutes.PlatformUsers, label: 'All users' },
    { path: PagesRoutes.PlatformAudit, label: 'Activity history' },
    { path: PagesRoutes.PlatformSuperAdmins, label: 'Super admin access' }
];

const PlatformLayout = () => (
    <PlatformGuard>
        <Shell>
            <PlatformTabsNav>
                <PlatformTabsInner>
                    {tabs.map((tab) => (
                        <PlatformTabNavLink key={tab.path} to={tab.path} end={tab.end}>
                            {tab.label}
                        </PlatformTabNavLink>
                    ))}
                </PlatformTabsInner>
            </PlatformTabsNav>
            <Content>
                <Outlet />
            </Content>
        </Shell>
    </PlatformGuard>
);

const Shell = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    min-height: 0;
`;

const PlatformTabNavLink = styled(NavLink)`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: fit-content;
    height: 30px;
    padding: 5px 15px 0;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.3s;
    font-size: ${(p) => p.theme.fontSizes.tabText};
    color: ${(p) => p.theme.colors.tabNormal};
    border-bottom: 4px solid transparent;
    white-space: nowrap;

    &:hover {
        color: ${(p) => p.theme.colors.tabActive};
    }

    &.active {
        color: ${(p) => p.theme.colors.tabActive};
        font-weight: bold;
        border-bottom-color: ${(p) => p.theme.colors.tabActive};
    }

    @media screen and (max-width: 768px) {
        height: 52px;
        font-size: ${(p) => p.theme.fontSizes.tabTextMobile};
        font-weight: bold;
    }
`;

const Content = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
`;

export default PlatformLayout;
